import { z } from 'zod';

export const BankServiceDtoSchema = z
  .object({
    displayName: z.string(),
    imageUrl: z.string(),
  })
  .describe('BankServiceDtoSchema');

export const GetBanksServiceResponseSchema = z
  .object({
    banks: z.array(BankServiceDtoSchema),
  })
  .describe('GetBanksServiceResponseSchema');

export type BankServiceDto = z.infer<typeof BankServiceDtoSchema>;
export type GetBanksServiceResponse = z.infer<typeof GetBanksServiceResponseSchema>;
